import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { ApiLoginRequest, ApiLoginResponse } from '~shared/types';

export const signIn = async (signinData: ApiLoginRequest) => {
  const { data }: AxiosResponse<ApiLoginResponse> = await HttpService.post(
    'auth/signin',
    signinData,
  );

  return data;
};
